import React, {Component} from 'react';
import {withTranslation} from "react-i18next";
import DefaultLayout from "../../components/DefaultLayout";
import {Avatar, Icon, List} from 'antd';
import {ActivityIndicator, NavBar, WingBlank} from 'antd-mobile';
import UserCarService from "../../apiServices/UserCarService";
import {Link} from "react-router-dom";
import carInsurance from "../../resources/images/icons/car-insurance-protection.svg";
import DocumentTitle from "react-document-title";
import OrderService from "../../apiServices/OrderService";

class ChooseCar extends Component {

    constructor(props){
        super(props);
        this.state = {
            height: props.height,
            hasError: false,
            hiddenBtn: false,
            userCars: null,
            carLength: 0,
            showLoading: true
        };
    }

    componentDidMount() {
        this.setState({height: window.innerHeight + 'px'});

        UserCarService.list().then(response => {
            this.setState({userCars: response.data, carLength: response.data.length, showLoading: false});
        }).catch(function(error){
            console.log(error);
        });
    }

    carDetail = (object_id, object_stat) => {
        OrderService.findByObjectId(object_id).then(response=>{
            if(response.code === 3){
                this.props.history.push('/mua-bao-hiem?object_id='+object_id);
            }else if(response.data.stat === 1){
                this.props.history.push('/thong-tin-nguoi-mua?object_id='+object_id);
            }else if(response.data.stat === 2 && object_stat === 3){
                this.props.history.push('/chi-tiet-xe?id='+object_id);
            }else if(response.data.stat === 2){
                this.props.history.push('/hoan-thien-ho-so?object_id='+object_id);
            }else {
                this.props.history.push('/chi-tiet-hop-dong?object_id='+object_id);
            }
        }).catch(function(error){
            console.log('Lỗi: '+error);
        });
    };

    render() {
        if (this.state.showLoading===true) {
            return (<div className='App-block bgWhite' style={{minHeight: this.state.height}}>
                <DefaultLayout {...this.props} title="Mua Bảo hiểm cho ô tô" classNameContent="bgWhite" page_type={1} hiddenFt={true}>
                    <div className="wrap-content">
                        <ActivityIndicator toast text="Loading..." animating={this.state.showLoading}/>
                    </div>
                </DefaultLayout>
            </div>);
        }else if (this.state.carLength !== 0){
            return (<DocumentTitle title={'Mua Bảo hiểm cho ô tô'}>
                    <div className="main-container">
                        <NavBar
                            mode="dark"
                            icon={<Icon type="left" />}
                            onLeftClick={() => this.props.history.push('/')}
                            rightContent={[<Icon type="plus" onClick={() => this.props.history.push('/them-xe-moi?buyins=1')} />]}
                            className='top-nav-bar'
                        >Mua Bảo hiểm cho ô tô</NavBar>
                        <div style={{margin: '0 15px'}}>
                        <List
                            itemLayout="horizontal"
                            dataSource={this.state.userCars}
                            renderItem={item => (
                                <List.Item key={item.id} className='list-carItem' onClick={() => this.carDetail(item.id, item.stat)}>
                                    <List.Item.Meta
                                        avatar={<Avatar src={carInsurance}/>}
                                        title={item.brand+' - '+item.product}
                                        description={item.plate_number}
                                    />
                                </List.Item>
                            )}
                        />
                    </div>
                </div>
            </DocumentTitle>);
        }else
            return (
                <div className='App-block bgWhite' style={{minHeight: this.state.height}}>
                    <DefaultLayout {...this.props} title="Mua Bảo hiểm cho ô tô" classNameContent="bgWhite" page_type={1} hiddenFt={true}>
                        <div className="wrap-content">
                            <WingBlank size="md" className='text-center'>
                            <div style={{ paddingTop: 60, color: '#000000' }}>Bạn chưa có hồ sơ xe nào</div>
                            </WingBlank>
                            <WingBlank size="md" className='text-center'>
                            <img style={{ width: '25%' }} src={require('../../resources/images/icons/car-service.svg')} alt="" />
                            </WingBlank>
                            <WingBlank size="md" className='text-center'>
                                <div className='boxBuyNow' style={{ marginTop: '10px' }}>
                                    <Link to='/them-xe-moi?buyins=1' className="ant-btn btn-next-action">Tạo hồ sơ xe mới</Link>
                                </div>
                            </WingBlank>
                        </div>
                    </DefaultLayout>
                </div>
            );
    }
}

export default (withTranslation())(ChooseCar);
